module.exports = "<div [@condense]=\"menuState\" (@condense.done)=\"animationDone($event)\" class=\"condense-wrapper\">\n\t<ng-content></ng-content>\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/system/core/side-menu/condense/condense.component.html
// module id = ./src/app/system/core/side-menu/condense/condense.component.html
// module chunks = main